export const domain = process.env.REACT_APP_DOMAIN;
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const domain_need = process.env.REACT_APP_DOMAIN_NEED;
